import { cn } from "@repo/utils";
import type { RowBase } from "../data-table.js";
import type { ColumnDef } from "../data-table.types.js";

type Props<TRow extends RowBase> = {
  columns: ColumnDef<TRow>[];
  showActionsColumn: boolean;
  loadingRowCount?: number;
};

export const DataTableLoading = <TRow extends RowBase>({
  columns,
  showActionsColumn,
  loadingRowCount = 5,
}: Props<TRow>) => (
  <>
    {Array.from({ length: loadingRowCount }).map((_, index) => (
      <tr
        key={index}
        className="border-gxe-border flex min-w-0 animate-pulse items-center gap-4 border-b py-3 last:border-b-0"
      >
        {columns.map((col, colIndex) => (
          <td key={colIndex} className={cn("flex min-w-0 text-sm", col.width || "flex-1")}>
            <div className="h-4 w-3/4 rounded bg-gray-200"></div>
          </td>
        ))}
        {showActionsColumn && (
          <td className="sticky right-0 z-10 flex min-w-0 flex-shrink-0 items-center justify-end">
            <div className="h-4 w-8 rounded bg-gray-200"></div>
          </td>
        )}
      </tr>
    ))}
  </>
);
